import { Directive, Input, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { PermissionService } from '../../admin/services/permission.service';

/**
 * Directiva para mostrar/ocultar elementos basándose en permisos del usuario
 * 
 * Uso en HTML:
 * <button *hasPermission="'orders.create'">Create Order</button>
 * <button *hasPermission="['orders', 'create']">Create Order</button>
 * <div *hasPermission="'admin.manage_users'">Admin Panel</div>
 */
@Directive({
  selector: '[hasPermission]',
  standalone: true
})
export class HasPermissionDirective implements OnInit {
  
  private permission: string | string[];
  private hasView = false;

  @Input() set hasPermission(val: string | string[]) {
    this.permission = val;
    this.updateView();
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionService: PermissionService
  ) { }

  ngOnInit() {
    this.updateView();
  }

  private updateView() {
    const shouldShow = this.checkPermission();
    
    if (shouldShow && !this.hasView) {
      // Crear la vista solo si no existe
        this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!shouldShow && this.hasView) {
      // Eliminar la vista solo si existe
        this.viewContainer.clear();
      this.hasView = false;
    }
  }

  private checkPermission(): boolean {
    if (!this.permission) {
      return false;
    }

    // Si es un string en formato "module.action"
    if (typeof this.permission === 'string') {
      return this.permissionService.hasPermissionValue(this.permission);
    }

    // Si es un array [module, action]
    if (Array.isArray(this.permission) && this.permission.length === 2) {
      return this.permissionService.hasPermission(this.permission[0], this.permission[1]);
    }

    return false;
  }
}
